export namespace DateFormatConstants {
  export const DATE_FORMAT_FULL = 'M/DD/YY h:mm a (tz)';
  export const DATE_FORMAT_SHORT_TIMEZONE = 'M/DD/YY h:mm A (z)';
  export const PICKUP_DATE_MEDIUM = 'ddd M/DD/YY - h:mm A';
  export const PICKUP_DATE_RIDE_SUBSCRIPTION = 'h:mm A';
  export const PICKUP_DATE_TODAY = '[Today] [at] h:mm A';
  export const PICKUP_DATE_MEDIUM_DETAILED = 'ddd, MMM D [at] h:mm A';
  export const PICKUP_DATE_SHORT = 'M/D/YY, h:mm a';
  export const RIDE_SUBSCRIPTION_DATE = 'ddd, MMMM D, YYYY';
  export const PAYOUT_DATE = 'M/D/YY';
  export const DATE_OF_BIRTH = 'M/D/YYYY';
  export const CARD_EXPIRATION = 'MM/YYYY';
  export const ISO_OFFSET_DATE = 'YYYY-MM-DDZ';
  export const ISO_LOCAL_DATE = 'YYYY-MM-DD';
  export const ISO_LOCAL_TIME = 'HH:mm:ss';
  export const ISO_LOCAL_DATE_TIME = ISO_LOCAL_DATE + 'T' + ISO_LOCAL_TIME;
  export const SHORT_MONTH_ORDINAL_DAY = 'MMM Do';
  export const RIDER_APP_PICKUP_DATE_FORMAT = 'ddd, MMM D';
  export const RIDER_APP_PICKUP_DATE_FORMAT_TODAY = 'MMM D';
  export const RIDER_APP_PICKUP_TIME_FORMAT = '[at] h:mm A';
  export const SHORT_TIME = 'h:mm';
  export const TIME = 'h:mm A';
  export const TIME_LOWERCASE = 'h:mm a';
  export const TIME_TWENTY_FOUR_HOUR = 'HH:mm';
  export const UPCOMING_RIDE_GROUP_DATE_FORMAT = 'MMMM';
  export const RIDE_REQUEST_GROUP_DATE_FORMAT = 'dddd, MMMM D';
  export const PAST_RIDE_GROUP_DATE_FORMAT = 'MMMM D YYYY';
  export const TIME_SHORT_TIMEZONE = 'h:mm A (z)';
  export const TIME_INPUT_VALUE = 'HH:mm';
  export const RIDE_GROUP_KEY_DATE_FORMAT = 'YYYY-MM-DD';
  export const URL_DATE_FORMAT = 'YYYY-MM-DD';
  export const URL_TIME_FORMAT = 'HH:mm';
  export const FULL_MONTH = 'MMMM';
  export const FULL_MONTH_AND_YEAR = 'MMMM YYYY';
  export const DOCUMENT_EXPIRATION_DATE_FORMAT = 'MM/DD/YYYY';
  export const MM_DD_YYYY_SLASH = 'M/DD/YYYY';
}
